import { mapGetters } from "vuex";
import { CreateLogEntryObj } from "../helpers/Utils";
import { SiteTime } from "@primayer/poi-classes";
export const PageEventHandlers = {
  data() {
    return {
      pdpIndex: null,
      pdpIds: null
    };
  },
  computed: {
    ...mapGetters("login", {
      userId: "technicianId",
      authUser: "authUser"
    }),
    paused() {
      if (
        this.correlationData &&
        this.correlationData.technicianData &&
        this.correlationData.technicianData.paused != null
      ) {
        return this.correlationData.technicianData.paused;
      }
      return false;
    },
    isOnSite() {
      if (
        this.correlationData &&
        this.correlationData.technicianData &&
        this.correlationData.technicianData.onSiteTimes.length > 0
      ) {
        let arraySize = this.correlationData.technicianData.onSiteTimes.length;
        let lastOnSite = this.correlationData.technicianData.onSiteTimes[
          arraySize - 1
        ];
        if (!lastOnSite.leaving) return true;
      }
      return false;
    }
  },
  methods: {
    async onPauseButton() {
      this.updating = true;
      const pauseValue = !this.paused;
      const action = pauseValue ? "paused" : "un-paused";
      //create logs
      const newLog = CreateLogEntryObj(this.correlationData.id, action);
      const data = { isPause: pauseValue, logEntry: newLog };

      await this.$store.dispatch("poi/PausePoi", data);
      this.updating = false;
    },
    async onSiteButtonClicked() {
      this.updating = true;
      const newSiteTime = new SiteTime({
        arriving: new Date()
      });
      let mappedOnSiteTimes = this.correlationData.technicianData.onSiteTimes.map(
        x => ({
          arriving: x.arriving,
          leaving: x.leaving
        })
      );
      const allOnSiteTimes = [...mappedOnSiteTimes, newSiteTime];
      const newLog = CreateLogEntryObj(
        this.correlationData.id,
        "arrived on site"
      );
      await this.$store.dispatch("poi/onSitePoi", {
        data: allOnSiteTimes,
        logEntry: newLog
      });

      this.updating = false;
    },
    async onLeaveSiteButton() {
      this.updating = true;
      let mappedOnSiteTimes = this.correlationData.technicianData.onSiteTimes.map(
        x => ({
          arriving: x.arriving,
          leaving: x.leaving
        })
      );
      const allOnSiteTimes = [...mappedOnSiteTimes];
      //  create logs
      const newLog = CreateLogEntryObj(this.correlationData.id, "leaving site");
      allOnSiteTimes[allOnSiteTimes.length - 1].leaving = new Date();
      await this.$store.dispatch("poi/onSitePoi", {
        data: allOnSiteTimes,
        logEntry: newLog
      });
      this.updating = true;
      this.$router.push({ name: "group" }).catch(() => {});
    },
    onMapButton(id) {
      this.$router.push({ name: "mapDetail", params: { id } });
    },
    onDataButton(id) {
      this.$router.push({ name: "dataDetail", params: { id } });
    },
    doAllFoundLeaksContainGPS() {
      let answer = true;
      this.leaks.forEach(leak => {
        if (!leak.leakCoords) {
          answer = false;
        }
      });
      return answer;
    },
    doAllFoundLeaksContainAClassification() {
      let answer = true;
      this.leaks.forEach(leak => {
        if (!leak.classification || leak.classification === "NONE") {
          answer = false;
        }
      });
      return answer;
    }
  }
};
